<template>
  <model-form
    :model="voucher"
    modal-type="modal"
    :before-save="saveCard"
  >
    <div>
      <div class="row q-col-gutter-sm q-mb-md">
        <model-form-input
          field="uid"
          class="col-12 sensitive-data"
          label="UID"
          readonly
        />
        <model-form-input
          field="voucherType.name"
          class="col-12"
          label="Voucher Type"
          readonly
        />
        <model-form-select
          field="user"
          class="col-12 sensitive-data"
          label="User"
          use-input
          input-debounce="300"
          input-style="search"
          :options="users.data"
          option-label="name"
          map-options
          clearable
          @filter="userFilterFunction"
        />
        <q-input
          v-if="voucher.issuedVoucherPackage && voucher.issuedVoucherPackage.isRemote"
          :model-value="voucher.issuedVoucherPackage && voucher.issuedVoucherPackage.card && voucher.issuedVoucherPackage.card.uid"
          class="col-12 sensitive-data"
          label="Package Card Barcode"
          clearable
          :disable="voucher.isTranslation"
          @update:model-value="value => setCard(voucher.issuedVoucherPackage, value)"
        />
        <q-input
          v-else
          :model-value="voucher.card && voucher.card.uid"
          class="col-12 sensitive-data"
          label="Card Barcode"
          clearable
          :disable="voucher.isTranslation"
          @update:model-value="value => setCard(voucher, value)"
        />
        <model-form-select
          field="state"
          class="col-12"
          label="State"
          :display-value="!!voucher.redeemedAt ? 'Redeemed' : $_.startCase(voucher.state)"
          :options="$mh.asOptions(VOUCHER_STATES.OPTIONS)"
          :disable="!!voucher.redeemedAt || loading"
          emit-value
          @update:model-value="onStateChange"
        />
        <iso-date-input
          v-model="voucher.expiresAt"
          class="col-12"
          label="Expires At"
          :disable="voucher.isTranslation"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import Card from 'src/models/card/Card'
import { VOUCHER_STATES } from 'src/models/voucher/Voucher'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'VoucherForm',
  components: {
    IsoDateInput,
    ModelForm
  },
  configuration: ['voucherTypes'],
  models: {
    voucher: {
      voucherType: {
        fields: ['id', 'name']
      },
      user: 'identify',
      card: {
        fields: ['id', 'uid', 'humanUid']
      },
      issuedVoucherPackage: {
        fields: ['id', 'uid'],
        card: 'default'
      }
    },
    users: {
      fields: ['id', 'firstName', 'lastName'],
      variables () {
        return {
          orderBy: 'firstName',
          searchString: this.userSearchValue,
          limit: 20
        }
      }
    }
  },
  data () {
    return {
      userSearchValue: '',
      loading: false
    }
  },
  created () {
    _.extend(this, { VOUCHER_STATES })
  },
  methods: {
    async saveCard (model) {
      let cardable = null
      if (model.issuedVoucherPackage) {
        cardable = model.issuedVoucherPackage
      } else {
        cardable = model
      }

      if ((!cardable?.card?.uid || cardable?.card?.uid === '') && !!cardable?.card?.isRemote) {
        await cardable.card.delete()
        cardable.card = null
      }

      if (cardable.typeName === 'IssuedVoucherPackage') {
        await cardable.save()
      }
    },
    setCard (cardable, cardUid) {
      if (!cardable.card) {
        cardable.card = new Card({ uid: cardUid })
      } else {
        cardable.card.uid = cardUid
      }
    },
    userFilterFunction (val, update, abort) {
      update(() => {
        this.userSearchValue = val
      })
    },
    async onStateChange (state) {
      let results
      this.loading = true
      if (state === VOUCHER_STATES.VALID) {
        results = await this.voucher.validateVoucher()
      } else if (state === VOUCHER_STATES.VOIDED) {
        results = await this.voucher.voidVoucher()
      }
      if (results.errors.length) {
        this.$mh.showErrors(results.errors)
      }
      this.loading = false
    }
  }
}

</script>
